import React from 'react';
import { useGoogleCmp, openAdvertisingSettings } from '../utils/googleCmp';
import { GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES } from '../ads/googleInterstitialAttributes';

export default function AdvertisingConsentButton({ className, children }) {
  const cmp = useGoogleCmp();
  if (!cmp.settingsAvailable) return null;

  return (
    <button
      type="button"
      className={className}
      {...GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES}
      disabled={cmp.isBusy}
      onClick={openAdvertisingSettings}
    >
      {children || 'Consenso pubblicitario'}
    </button>
  );
}
